// Autogenerated by Hanako
import { Debug } from './components/Debug';
import { LazyLoader } from './components/LazyLoader';
import { Carousel } from '../twig/components/Carousel';
import { Cuckoo } from '../../views/twig/components/Cuckoo';
import { Menu } from '../../views/twig/components/Menu';
import { CartIcon } from '../twig/components/CartIcon';
(new Debug()).init();
(new LazyLoader()).init();
(new Carousel()).init();
(new Cuckoo()).init();
(new Menu()).init();
(new CartIcon()).init();
